import { Type } from '@angular/core';
export class NavigationItem {
    constructor(public id: string, public label: string, public component: Type<any>, public data: any, public callBack:Function, public required:Boolean = false, public args: any = {} ) {}
  }